<template>
  <div class="wrapper">
    <div class="progress" :style="width" :class="color" />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const DEFAULT_COLOR = 'bg-blue-600';

const props = defineProps({value: Number, max: Number, color: String});

// Safely calculate progress percentage
const calc = (m, v) => Math.min(100, parseInt((v / m) * 100));
const safe = (m, v) => (v <= 0 || m <= 0) ? 0 : calc(m, v);

// Determine ratio and calculate width of progress bar
const ratio = computed(() => safe(props.max, props.value));
const width = computed(() => ({width: ratio.value + '%'}));

// Determine the color
const color = props.color ?? DEFAULT_COLOR;
</script>

<style scoped>
.wrapper
{
  @apply w-full rounded-full;
  @apply bg-gray-200 dark:bg-gray-700;
}

.progress
{
  @apply h-4 leading-none rounded-full;
  @apply text-xs font-medium text-blue-100 text-center;
}
</style>
